import { useLingui } from '@lingui/react';
import { Grid, Group, Tabs } from '@mantine/core';
import { WalletTabItem } from './WalletTabItem';
export const WalletTabControl = () => {
  const {
    i18n
  } = useLingui();
  return <Group justify="center">
      <Tabs.List maw={728}>
        <Grid gutter={{
        base: 10,
        sm: 12,
        md: 22
      }}>
          <Grid.Col span={2.4}>
            <Tabs.Tab value="wallet" w={{
            base: '100%',
            sm: 135,
            md: 128
          }} h={{
            base: 70,
            sm: 46
          }}>
              <WalletTabItem icon="icon-pr-line-wallet" title={i18n._('Wallet')} />
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={2.4}>
            <Tabs.Tab value="deposit" w={{
            base: '100%',
            sm: 135,
            md: 128
          }} h={{
            base: 70,
            sm: 46
          }}>
              <WalletTabItem icon="icon-pr-line-log-in" title={i18n._('Deposit')} />
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={2.4}>
            <Tabs.Tab value="withdraw" w={{
            base: '100%',
            sm: 135,
            md: 128
          }} h={{
            base: 70,
            sm: 46
          }}>
              <WalletTabItem icon="icon-pr-line-log-out" title={i18n._('Withdraw')} />
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={2.4}>
            <Tabs.Tab value="coupons" w={{
            base: '100%',
            sm: 135,
            md: 128
          }} h={{
            base: 70,
            sm: 46
          }}>
              <WalletTabItem icon="icon-pr-line-coupon" title={i18n._('Coupons')} />
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={2.4}>
            <Tabs.Tab value="referrals" w={{
            base: '100%',
            sm: 135,
            md: 128
          }} h={{
            base: 70,
            sm: 46
          }}>
              <WalletTabItem icon="icon-pr-line-referral" title={i18n._('Referrals')} />
            </Tabs.Tab>
          </Grid.Col>
        </Grid>
      </Tabs.List>
    </Group>;
};